import React, { useEffect, useRef, useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { useOrg } from '../../hooks/useOrg';

/**
 * Sidebar badge: active hospital + dropdown for multi-org (uses useOrg only).
 */
const OrgSwitcherBadge = () => {
  const { isMultiOrg, activeOrg, availableOrgs, setActiveOrg, isLoading } = useOrg();
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onDocClick = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, [open]);

  if (!isMultiOrg || isLoading) return null;

  const label = activeOrg?.name || '—';

  return (
    <div ref={rootRef} style={{ position: 'relative', marginBottom: 8 }}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 6,
          width: '100%',
          padding: '8px 10px',
          borderRadius: 8,
          border: '1px solid rgba(255,255,255,0.2)',
          background: 'rgba(255,255,255,0.08)',
          color: 'inherit',
          cursor: 'pointer',
          fontSize: 13
        }}
      >
        <span style={{ flex: 1, textAlign: 'left', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {label}
        </span>
        <ChevronDown size={16} style={{ opacity: 0.85 }} />
      </button>
      {open && (
        <div
          style={{
            position: 'absolute',
            left: 0,
            right: 0,
            bottom: '100%',
            marginBottom: 4,
            maxHeight: 220,
            overflowY: 'auto',
            background: '#1e293b',
            border: '1px solid #334155',
            borderRadius: 8,
            zIndex: 50,
            boxShadow: '0 8px 24px rgba(0,0,0,0.25)'
          }}
        >
          {availableOrgs.map((org) => (
            <button
              key={org.id}
              type="button"
              onClick={async () => {
                await setActiveOrg(org.id);
                setOpen(false);
              }}
              style={{
                display: 'block',
                width: '100%',
                textAlign: 'left',
                padding: '10px 12px',
                border: 'none',
                background: 'transparent',
                color: '#f8fafc',
                cursor: 'pointer',
                fontSize: 13
              }}
            >
              {org.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default OrgSwitcherBadge;
